import React from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import SelectDropDown from '../common/ReactHookForm/SelectDropDown';
import useMutateRegisration from '../Hooks/login/useMutateRegistration';
import Spinner from '../common/Spinner';


const Register = () => {
    const { register, handleSubmit, reset, setError, clearErrors, formState } = useForm({
        mode: 'onChange'
    });
    const { errors } = formState;
    const history = useHistory();

    const groups = ['RND', 'MFG', 'QC', 'CDG']

    const createMutation = useMutateRegisration();

    const onSubmit = (data) => {
        createMutation.mutate({ data },
            {
                onSuccess: (data) => {
                    reset();
                    history.push('/login');
                },
                onError: (error) => {
                    console.log(error)
                    reset();

                }
            })
    };
    return (
        <>
            <div className='grid place-items-start'>
                <h1 className="pt-10 pb-6 font-extrabold text-custom-green">Register</h1>

                <form className='grid grid-cols-2 gap-4' onSubmit={handleSubmit(onSubmit)}>

                    <label className='pt-3 text-custom-green font-light text-left'>User Email</label>
                    <input type="email"
                        placeholder="Enter your email address"
                        className="w-full custom-inset-shadow border border-gray-300 px-4 py-2 rounded-md"
                        {...register("email", {
                            required: true,
                            pattern: {
                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                message: "Invalid email address"
                            }
                        })}
                    />
                    <span className='pt-3'></span>
                    <p className='text-red-800 px-4 py-2'>{errors?.email?.message}</p>
                    <label className='pt-3 text-custom-green font-light text-left'>Role</label>
                    <SelectDropDown className="w-full custom-inset-shadow border border-gray-300 px-4 py-2 rounded-md "
                        {...register("group", { required: true })} options={groups} name="group" />
                    <div className="pt-10 flex justify-end">
                        <button className={` text-white px-4 py-2 rounded  text-right items-ensd shadow-md 
                        ${formState.isDirty && formState.isValid ? "bg-green-700" : 'bg-gray-400 cursor-not-allowed'}`}
                            type="submit" disabled={!(formState.isDirty && formState.isValid)}>Register</button>
                    </div>
                    {createMutation.isLoading &&
                        <div className="backdrop center-child">
                            <Spinner text="Registering User...." />
                        </div>
                    }
                </form>

            </div>
        </>
    )
};

export default Register;